import React__default from 'react';
import { useTranslate } from '@awardit/react-use-translate';
import useFormat from '../../helpers/use-format.js';
import { getPriceSplit } from '../../helpers/points.js';
import styles from 'ui-components/PriceSplit.scss';

var PriceSplit = function PriceSplit(_ref) {
  var pointsPrice = _ref.pointsPrice,
    className = _ref.className,
    _ref$exVat = _ref.exVat,
    exVat = _ref$exVat === void 0 ? false : _ref$exVat,
    formatPriceExt = _ref.formatPriceExt,
    price = _ref.price;
  var t = useTranslate();
  var _useFormat = useFormat(),
    formatPoints = _useFormat.formatPoints,
    formatPrice = _useFormat.formatPrice;
  var priceSplit = getPriceSplit(pointsPrice, exVat, price);
  if (!priceSplit || priceSplit === null) {
    return null;
  }
  var renderSplit = function renderSplit(s, i) {
    switch (s.type) {
      case "points":
        return /*#__PURE__*/React__default.createElement("div", {
          key: i,
          className: styles.pointsField
        }, i > 0 && /*#__PURE__*/React__default.createElement("span", null, t("OR"), "\xA0"), /*#__PURE__*/React__default.createElement("span", null, formatPoints(s.values.points)));
      case "currency":
        return /*#__PURE__*/React__default.createElement("div", {
          key: i,
          className: styles.currencyField
        }, i > 0 && /*#__PURE__*/React__default.createElement("span", null, t("OR"), "\xA0"), /*#__PURE__*/React__default.createElement("span", null, formatPriceExt !== undefined ? formatPriceExt(s.values.currency) : formatPrice(s.values.currency)));
      case "split":
        return /*#__PURE__*/React__default.createElement("div", {
          key: i,
          className: styles.splitField
        }, i > 0 && /*#__PURE__*/React__default.createElement("span", null, t("OR"), "\xA0"), /*#__PURE__*/React__default.createElement("span", null, formatPoints(s.values.points)), /*#__PURE__*/React__default.createElement("span", {
          className: styles.currency
        }, "\xA0+\xA0", formatPriceExt !== undefined ? formatPriceExt(s.values.currency) : formatPrice(s.values.currency)));
    }
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: className
  }, priceSplit.map(renderSplit));
};

export { PriceSplit };
//# sourceMappingURL=index.js.map
